import { format } from 'date-fns';
/**
 * The default ARIA label for the Weekday element.
 */
export var labelWeekday = function (day, options) {
    return format(day, 'cccc', options);
};
//# sourceMappingURL=labelWeekday.js.map